var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { getApiUrl } from '@/shared/utils/helpers';
import { exportFile } from 'quasar';
let AccountManagementReportsTabContainer = class AccountManagementReportsTabContainer extends Vue {
    constructor() {
        super(...arguments);
        this.selectedMonth = new Date();
    }
    created() {
        const today = new Date();
        this.selectedMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    }
    disableFutureMonths(date) {
        const today = new Date();
        const startOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        return date.getTime() >= startOfCurrentMonth.getTime();
    }
    getDateRange() {
        const initialDate = new Date(this.selectedMonth);
        initialDate.setDate(1);
        initialDate.setHours(0, 0, 0, 0);
        const endDate = new Date(initialDate);
        endDate.setMonth(initialDate.getMonth() + 1);
        return {
            isoInitialDate: initialDate.toISOString(),
            isoEndDate: endDate.toISOString(),
        };
    }
    generateCsv(data, filename) {
        if (!data || data.length === 0) {
            this.$q.notify({
                type: 'warning',
                message: 'Nenhum dado encontrado para exportar',
            });
            return;
        }
        const keys = Object.keys(data[0]);
        const csvContent = [
            keys.join(','),
            ...data.map(row => keys
                .map(key => {
                let cell = row[key] === null || row[key] === undefined
                    ? ''
                    : String(row[key]);
                cell = cell.replace(/"/g, '""');
                if (cell.search(/("|,|\n)/g) >= 0) {
                    cell = `"${cell}"`;
                }
                return cell;
            })
                .join(',')),
        ].join('\n');
        const status = exportFile(filename, csvContent, 'text/csv');
        if (status !== true) {
            this.$q.notify({
                type: 'negative',
                message: 'O navegador bloqueou o download do arquivo',
            });
        }
        else {
            this.$q.notify({
                type: 'positive',
                message: 'Download concluído!',
            });
        }
    }
    async exportPreviouslyExportedCnpjs() {
        this.$q.notify({
            type: 'positive',
            message: 'Relatório de CNPJs está sendo gerado e será exportado em breve',
        });
        const { isoInitialDate, isoEndDate } = this.getDateRange();
        const accountId = this.$store.getters['admin/get_selected_account'];
        try {
            const response = await Vue.axios.get(`${getApiUrl('v3')}/admin/account/${accountId}/reports/previously_exported_cnpjs`, {
                params: {
                    initial_date: isoInitialDate,
                    end_date: isoEndDate,
                },
            });
            const data = (response.data && response.data.data) || [];
            this.generateCsv(data, `cnpjs_exportados_${this.selectedMonth.toISOString().slice(0, 7)}.csv`);
        }
        catch (error) {
            console.error('Error generating report:', error);
            this.$q.notify({
                type: 'negative',
                message: 'Ocorreu um erro ao gerar o relatório',
            });
        }
    }
    async exportUserActivityStatus() {
        this.$q.notify({
            type: 'positive',
            message: 'Relatório de Status está sendo gerado e será exportado em breve',
        });
        const { isoInitialDate, isoEndDate } = this.getDateRange();
        const accountId = this.$store.getters['admin/get_selected_account'];
        try {
            const response = await Vue.axios.get(`${getApiUrl('v3')}/admin/account/${accountId}/reports/user_activity_status`, {
                params: {
                    initial_date: isoInitialDate,
                    end_date: isoEndDate,
                },
            });
            const data = (response.data && response.data.data) || [];
            this.generateCsv(data, `status_atividade_usuarios_${this.selectedMonth
                .toISOString()
                .slice(0, 7)}.csv`);
        }
        catch (error) {
            console.error('Error generating report:', error);
            this.$q.notify({
                type: 'negative',
                message: 'Ocorreu um erro ao gerar o relatório',
            });
        }
    }
};
AccountManagementReportsTabContainer = __decorate([
    Component
], AccountManagementReportsTabContainer);
export default AccountManagementReportsTabContainer;
